import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('tvde_user')); } catch { return null; }
  });

  useEffect(() => {
    if (user) localStorage.setItem('tvde_user', JSON.stringify(user));
    else localStorage.removeItem('tvde_user');
  }, [user]);

  const login = (token, userData) => {
    localStorage.setItem('tvde_token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('tvde_token');
    localStorage.removeItem('tvde_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
